import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import NewCartDropDown from './NewCartDropDown';



interface BookingBagProps {
  cartItems: any[];
  setCartItems: (items: any[]) => void;
  fetchCartItems: () => void;
}

const BookingBag: React.FC<BookingBagProps> = ({ cartItems, setCartItems, fetchCartItems }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const sessionId = localStorage.getItem('sessionId');

  useEffect(() => {
    fetchCartItems();
    console.log('cartItems:', cartItems.length);
  }, [cartItems.length, sessionId]);

  return (
    <div className='cart-button-container'>
      <button className='cart-count' onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        <span className='cart-header'>Booking bag&nbsp;</span>
        <FontAwesomeIcon className='shopping-basket' icon={faShoppingCart} />
        {cartItems.length > 0 && <span className='cart-counter'>{cartItems.length}</span>}
      </button>
      {isDropdownOpen && <NewCartDropDown cartItems={cartItems} setCartItems={setCartItems} fetchCartItems={fetchCartItems} isDropdownOpen={isDropdownOpen} setIsDropdownOpen={setIsDropdownOpen} />}
    </div>
  );
};

export default BookingBag;